var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#5C5C5C",
    viewBox: "0 0 14 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.378 24.036A2.144 2.144 0 0 0 14 22.52a2.16 2.16 0 0 0-.622-1.515l-8.249-8.34 8.25-8.34a2.143 2.143 0 0 0 .62-1.515 2.162 2.162 0 0 0-.62-1.515 2.118 2.118 0 0 0-1.5-.628 2.1 2.1 0 0 0-1.498.628L.62 11.16A2.143 2.143 0 0 0 0 12.676a2.16 2.16 0 0 0 .622 1.515l9.758 9.866c.808.817 2.17.817 2.998-.021Z"
  })));
};
export default SvgChevronLeft;